<template>
    <div class="image-upload">
          <input type="file" 
               ref="upload" 
               :value="imageInputVal"
               @change="customRequest($event)" 
               multiple="multiple" 
               class="upload-input" 
               :accept="accept" />
          <div class="img-container" >
            <template v-if="imageUrl.length">
              <div v-for="(item, index) in imageUrl" class="image-border" :key="index" >
                <img
                  :src="item"
                  class="image-preview"
                  ref="imagePreview"
                  @click="changeImg(index)">
                  <div class="close-icon" @click="deleteItem(index)" v-if="deletable">
                    <vs-icon
                      icon-pack="material-icons"
                      icon="close"></vs-icon>
                  </div>
              </div>
            </template>
            <div class="add-image" v-if="imageUrl.length < limitNum"  @click="changeImg('')">
              +
            </div>   
          </div>
    </div>
</template>

<script>
  import {CommonImgApi} from '@/modules/server-api/commodity-sys/common'
  export default {
    name: 'ImageUpload',
    props: {
      imageUrl :      { type: Array}, 
      limitNum :      { type: Number, default: 1 },   //限制最多上传几张
      limitSize:      { type: Number, default: 500 }, //限制上传图片大小
      imgResolutionW: { type: Number, default: 1024},  //限制分辨率
      imgResolutionH: { type: Number, default: 1024},   //限制分辨率
      accept:         { type: String, default: '.png,.img,.jpeg,.jpg,.gif,.bmp'},   //限制图片格式
      deletable: {
        type: Boolean, 
        default: false
      }
    },
    data() {
      return {
        imageInputVal: "",
        targetIndex:""
      }
    },
    computed: {
    },
    methods: {
      delEvent(){
        this.$emit("delEvent")
      },
      changeImg(index){
        if(typeof index == 'number'){
          this.targetIndex = index;
        }else{
          this.targetIndex = "";
        }
        this.$refs.upload.click();
      },
      customRequest (event) {        
        let fileObj = event.target.files[0];
        console.log(fileObj)
        const largeFlag = fileObj.size > this.limitSize * 1000;
        console.log(largeFlag)
        if(largeFlag){
          this.$notifyError("图片应小于"+this.limitSize / 1024+"M，请重新上传");
          return false;
        }
        //获取图片分辨率
        var reader = new FileReader();
        reader.readAsDataURL(fileObj);
        let _this = this;
        reader.onload = function () {
          var img = new Image()
          img.src = reader.result;
          img.onload = () => {
            // let w =img.width;
            // let h = img.height;
            // // console.log(w, h)
            // if(w <= _this.imgResolutionW && h<= _this.imgResolutionH){
              const formData = new FormData();
              formData.append('file', fileObj)
              formData.append('type', fileObj.type);
              return CommonImgApi.uploadImg(formData)
                .then(res => {
                  console.log(res,"=======")
                  if(res.status=="1"){
                     //返回链接                  
                  if(typeof _this.targetIndex == 'number'){
                     _this.imageUrl[_this.targetIndex] = res.data;
                     _this.$forceUpdate();
                  }else{
                     _this.imageUrl.push(res.data);
                  }
                 
                  _this.$emit('updateUrl',_this.imageUrl);
                  _this.imageInputVal = ''

                  }else{
                   this.$notifyError("上传失败");
                  }
                 
              });
            // }else{
            //   _this.$notifyError("图片分辨率应小于" + _this.imgResolutionW + '*' + _this.imgResolutionH + ",请重新上传");
            // }
          }
        }
      },
      // 删除图片
      deleteItem(index) {
        this.$vs.dialog({
          type: 'confirm',
          color: '#4090FF',
          title: `提示`,
          text: '确定要删除此项么?',
          acceptText: '确认',
          cancelText: '取消',
          accept: () => {
            this.imageUrl.splice(index, 1);
            this.$forceUpdate();
            this.$emit('updateUrl',this.imageUrl);
          }
        })
      }
    },
    mounted(){
      this.$nextTick(() => {
        console.log(this.$refs['imagePreview'])
        
      })
    }
  }
</script>
<style lang="scss" scoped>
@mixin flex-mixin($direction, $align, $justify) {
  display: flex;
  flex-direction: $direction;
  align-items: $align;
  justify-content: $justify;
}

    .upload-input{
      display: none;
    }
    .img-container{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      
      .image-border {
        border: 1px solid #ccc;
        margin-right: 10px;
        border-radius: 5px;
        position: relative;
        margin-bottom: 10px;
        width:100px;
        height: 100px;
        overflow: hidden;
        @include flex-mixin(column, center, center);

        .close-icon {
          position: absolute;
          top: 3px;
          right: 3px;
          z-index: 1;
          width: 18px !important;
          height: 18px !important;
          line-height: 18px;
          text-align: center;
          background-color: #4090FF;
          border-radius: 50%;
          color: #fff;
          cursor: pointer;
          .vs-icon {  
            font-size: 18px;
          }
          // /deep/ .vs-button-backgroundx {
          //   width: 10px !important;
          //   height: 10px !important;
          // }
        }
      }
      .image-preview{
        height: 100%;
        border-radius: 5px;
        vertical-align: middle;
      }
    }
    .add-image{
        width: 100px;
        height: 100px;
        border: 1px solid #D8D6DE;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        color: #4090FF;
        margin-bottom: 10px;
        &:hover{
          cursor: pointer;
        }
    }
</style>
